import { render } from "./MRadio.vue?vue&type=template&id=2648a36d"
import script from "./MRadio.vue?vue&type=script&lang=js"
export * from "./MRadio.vue?vue&type=script&lang=js"

import "./MRadio.vue?vue&type=style&index=0&id=2648a36d&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__